/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFwStatsVictoryPoints } from './GetFwStatsVictoryPoints';
import {
    GetFwStatsVictoryPointsFromJSON,
    GetFwStatsVictoryPointsFromJSONTyped,
    GetFwStatsVictoryPointsToJSON,
    GetFwStatsVictoryPointsToJSONTyped,
} from './GetFwStatsVictoryPoints';
import type { GetFwStatsKills } from './GetFwStatsKills';
import {
    GetFwStatsKillsFromJSON,
    GetFwStatsKillsFromJSONTyped,
    GetFwStatsKillsToJSON,
    GetFwStatsKillsToJSONTyped,
} from './GetFwStatsKills';

/**
 * 200 ok object
 * @export
 * @interface GetFwStats200Ok
 */
export interface GetFwStats200Ok {
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetFwStats200Ok
     */
    factionId: number;
    /**
     * 
     * @type {GetFwStatsKills}
     * @memberof GetFwStats200Ok
     */
    kills: GetFwStatsKills;
    /**
     * How many pilots fight for the given faction
     * @type {number}
     * @memberof GetFwStats200Ok
     */
    pilots: number;
    /**
     * The number of solar systems controlled by the given faction
     * @type {number}
     * @memberof GetFwStats200Ok
     */
    systemsControlled: number;
    /**
     * 
     * @type {GetFwStatsVictoryPoints}
     * @memberof GetFwStats200Ok
     */
    victoryPoints: GetFwStatsVictoryPoints;
}

/**
 * Check if a given object implements the GetFwStats200Ok interface.
 */
export function instanceOfGetFwStats200Ok(value: object): value is GetFwStats200Ok {
    if (!('factionId' in value) || value['factionId'] === undefined) return false;
    if (!('kills' in value) || value['kills'] === undefined) return false;
    if (!('pilots' in value) || value['pilots'] === undefined) return false;
    if (!('systemsControlled' in value) || value['systemsControlled'] === undefined) return false;
    if (!('victoryPoints' in value) || value['victoryPoints'] === undefined) return false;
    return true;
}

export function GetFwStats200OkFromJSON(json: any): GetFwStats200Ok {
    return GetFwStats200OkFromJSONTyped(json, false);
}

export function GetFwStats200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwStats200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'factionId': json['faction_id'],
        'kills': GetFwStatsKillsFromJSON(json['kills']),
        'pilots': json['pilots'],
        'systemsControlled': json['systems_controlled'],
        'victoryPoints': GetFwStatsVictoryPointsFromJSON(json['victory_points']),
    };
}

export function GetFwStats200OkToJSON(json: any): GetFwStats200Ok {
    return GetFwStats200OkToJSONTyped(json, false);
}

export function GetFwStats200OkToJSONTyped(value?: GetFwStats200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'faction_id': value['factionId'],
        'kills': GetFwStatsKillsToJSON(value['kills']),
        'pilots': value['pilots'],
        'systems_controlled': value['systemsControlled'],
        'victory_points': GetFwStatsVictoryPointsToJSON(value['victoryPoints']),
    };
}

